<template>
    <div>
        <label for="dropdown">{{ element.text }}</label>
        <select id="dropdown" class="form-control">
            <option :value="value" v-for="value in element.values">{{ value }}</option>
        </select>
    </div>
</template>

<script>
    export default {
        name: "SingleSelectElementPreview",
        props: {
            element: {
                type: Object
            }
        }
    }
</script>

<style scoped>
    #signatureBox {
        background-color: lightgray;
        border: 1px dotted gray;
    }

    h4 {
        color: white;
    }
</style>